// Insights → Pistil Next migration.
// See docs/specs/2026-08-12-pistil-next-migration-redirect.md

// "Pistil Next" destination key (destinationApp cookie + gateway routes).
export const PISTIL_NEXT_KEY = 'pistilnext';
export const INSIGHTS_KEY = 'insights';

// Migration phase switch. Changing ONLY this value toggles the behavior:
//   null            → Phase 1: if the user hasn't chosen Pistil Next, show the chooser.
//   PISTIL_NEXT_KEY → Phase 2: default-to-new — auto-redirect to Pistil Next unless opted out.
export const MIGRATION_DEFAULT_DESTINATION: string | null = null;
